import React from 'react'
import {Button, PopoverBody, UncontrolledPopover} from 'reactstrap'
import apiBarcode from '../../../services/api/apiBarcode'
import classNames from 'classnames'
import { Tooltip } from 'antd'

class ListItemsNoteOrder extends React.Component {
    state = {
        note: '',
        isLoadingNote: false
    }

    componentDidMount() {
        this._loadStateFromProps();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.note !== this.props.note) {
            this._loadStateFromProps()
        }
    }

    _loadStateFromProps = () => {
        const {note} = this.props;
        this.setState({note: note})
    }

    _handleChangeInput = (e) => {
        const {target: {name, value}} = e;
        this.setState({[name]: value});
    };

    _renderIconNote = () => {
        if (this.state.isLoadingNote)
            return <i className='icon-spinner2 spinner ml-2'/>;
        return <i className='icon-quill4 ml-2'/>;
    };

    _handleSaveNote = async () => {
        const {reloadItems} = {...this.props}
        this.setState({isLoadingNote: true});

        try {
            const {itemId} = this.props;
            const {note} = this.state;
            const resUpdated = await apiBarcode.updateBarcode(itemId, {note});

            const {success, message} = resUpdated.data;
            if (!success) throw new Error(message);
            reloadItems()
        } catch (e) {
            alert(e.message);
        }

        this.setState({isLoadingNote: false});
    };

    render() {
        const {id, showUpdate,} = this.props;
        const {note} = this.state;

        const classNameIcon = classNames({
            'icon-quill4': true,
            'text-danger': !!note,
            'text-success': !note
        });

        return (
            <div className='ListItemsNote'>
                <Tooltip title='Note'>
                    <i className={`${classNameIcon} cursor-pointer`} id={id}/>
                </Tooltip>
                <UncontrolledPopover placement='bottom' trigger='legacy' target={id}>
                    <PopoverBody>
                        <textarea className='form-control' name='note' value={note} onChange={this._handleChangeInput}/>
                        {
                            showUpdate &&
                            <div className='text-right mt-2'>
                                <Button color='primary' onClick={this._handleSaveNote}>
                                    Save Note
                                    {this._renderIconNote()}
                                </Button>
                            </div>
                        }
                    </PopoverBody>
                </UncontrolledPopover>
            </div>
        );
    }
}

ListItemsNoteOrder.defaultProps = {
    showUpdate: true
}

export default ListItemsNoteOrder;
